import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal';
import HeaderImage from './alert.png';
import Backend from '../../../stores/newBackend';
import { IStopGoGoogleConnect } from '../../../types/stopgogoogleconnect.interface';
import { IStopGoGoogleConnectKeywordStat } from '../../../types/stopgogoogleconnectkeywordstat.interface';
import { StoreContext } from '../../../stores';

interface PurgeDataModalProps {
  googleConnect: IStopGoGoogleConnect;
  keywords: IStopGoGoogleConnectKeywordStat[];
  onClose: (success: boolean) => void;
}

export function PurgeDataModal({
  googleConnect, keywords, onClose
}: PurgeDataModalProps) {
  const { authStore } = useContext(StoreContext);
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);

  const handlePurge = async function() {
    setSubmitting(true);
    const SEA: string[] = [];
    const SEO: string[] = [];

    for (const keyword of keywords) {
      if (keyword.SEA.IDs.length > 0) {
        SEA.push(...keyword.SEA.IDs);
      }
      if (keyword.SEO.IDs.length > 0) {
        SEO.push(...keyword.SEO.IDs);
      }
    }

    try {
      await Backend.purgeStopGoBrand(
        authStore.token,
        googleConnect.ID,
        SEA,
        SEO
      );
      onClose(true);
      toast(t('Purged data.'), { type: 'success' });
    } catch (err) {
      toast(t('Can\'t purge data.'), { type: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ConfirmModal
      headerImage={<img src={HeaderImage} alt='alert header' height={100} />}
      title={''}
      message={(
        <>
          <p>{t('You\'re about to purge data of ') + keywords.length + ' ' + t('keywords')}</p>
          <p>{t('Are you sure ?')}</p>
        </>
      )}
      setReset={onClose}
      setSubmit={handlePurge}
      isLoading={submitting}
    />
  );
}
